import avatar from '@assets/images/default-avatar.jpg';
import image from '@assets/images/no-image.png';

export const NoDataString = 'No Data';
export const UnknownValue = 'N/A';
export const DefaultAvatar = avatar;
export const NoImage = image;
